import { Component, Inject, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable, Subject } from 'rxjs';
import { ReportIssueComponent } from '../../components/report-issue/report-issue.component';
import { ReportIssueModel } from '../../components/report-issue/report-issue.model';
import { AppNotificationModel } from './app-notification.model';
import { UserMasterInstanceToken, UserMasterInterface } from '../../interfaces/user-master.interface';
import { ClientManagerInstanceToken, ClientManagerInterface } from '../../interfaces/client-manager.interface';

@Component({
    selector: 'pace-app-notification, pace-core-app-notification',
    templateUrl: './app-notification.component.html',
    styleUrls: ['./app-notification.component.scss'],
    standalone: false,
})
export class AppNotificationComponent {
    @Input()
    public model: AppNotificationModel;
    public displayReportAnIssueButton: boolean;
    private modalResultSubject: Subject<void>;
    public modalResult$: Observable<void>;
    public constructor(
        private readonly modalService: BsModalService,
        public readonly modalInstance: BsModalRef,
        @Inject(UserMasterInstanceToken) private readonly userMasterService: UserMasterInterface,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
    ) {
        this.displayReportAnIssueButton =
            !this.userMasterService.isPaceOnlineUser() && !this.clientManager.isPaceFormsFI();
        this.modalResultSubject = new Subject<void>();
        this.modalResult$ = this.modalResultSubject.asObservable();
    }

    public okClick(): void {
        this.modalResultSubject.next();
        this.modalResultSubject.complete();
        this.modalInstance.hide();
        if (this.model.okaction) {
            this.model.okaction();
        }
    }

    public openReportIssue(): void {
        this.modalService.show(ReportIssueComponent, {
            backdrop: 'static',
            class: 'modal-lg modal-fullscreen-lg-down',
            initialState: {
                model: new ReportIssueModel(this.model.bodyText),
            },
            ariaLabelledBy: 'report-issue-modal-title',
        });
    }
}
